export default "__VITE_ASSET__d9708ce4__"